export const flattenGroups = (groups) => {
  if (!groups) return [];
  const { history, ...rest } = groups;
  return [
    ...Object.values(rest).flat(),
    ...Object.values(history || {}).flat()
  ];
};
